"use client";

import dynamic from "next/dynamic";
const NotFound = dynamic(() => import("@/legacy/NotFound"), { ssr: false });

export default function NotFoundPage() {
  return <NotFound />;
}
